export class savedList{
    _id:any;
    accountId:any;
    productId:any;
    requiredQuantity:any;
    plannedPurchasedate:any;
    status:any
}